import { Routes } from '@angular/router';
import { authGuard, customerMessagesAuthGuard, projectAuthGuard, projectUpdateAuthGuard } from './auth';
import { pageHasChangesGuard } from '@guards/page-has-changes.guard';

export const routes: Routes = [
  { 
    path: 'projects', 
    loadComponent: () => import('./pages/projects/projects.component').then(m => m.ProjectsComponent),
    canActivate: [authGuard] 
  },
  { 
    path: 'projects/:projectId/dashboard', 
    loadComponent: () => import('./pages/project-dashboard/project-dashboard.page').then(m => m.ProjectDashboardPage),
    canActivate: [authGuard, projectUpdateAuthGuard] 
  },
  { 
    path: 'projects/:projectId/users', 
    loadComponent: () => import('./pages/users/users.page').then(m => m.UsersPage),
    canActivate: [authGuard, projectUpdateAuthGuard] 
  },
  { 
    path: 'projects/:projectId/hardware', 
    loadComponent: () => import('./pages/hardware/hardware.page').then(m => m.HardwarePage),
    canActivate: [authGuard, projectAuthGuard],
    canDeactivate: [pageHasChangesGuard]
  },
  { 
    path: 'projects/:projectId/checklists', 
    loadComponent: () => import('./pages/checklists/checklists.page').then(m => m.ChecklistsPage),
    canActivate: [authGuard, projectUpdateAuthGuard] 
  },
  { 
    path: 'projects/:projectId/checklists/new', 
    loadComponent: () => import('./pages/add-update-checklist/add-update-checklist.page').then(m => m.AddUpdateChecklistPage),
    canActivate: [authGuard, projectUpdateAuthGuard],
    canDeactivate: [pageHasChangesGuard]
  },
  { 
    path: 'projects/:projectId/checklists/:checklistId', 
    loadComponent: () => import('./pages/add-update-checklist/add-update-checklist.page').then(m => m.AddUpdateChecklistPage),
    canActivate: [authGuard, projectUpdateAuthGuard],
    canDeactivate: [pageHasChangesGuard]
  },
  { 
    path: 'projects/:projectId/services', 
    loadComponent: () => import('./pages/services/services.page').then(m => m.ServicesPage),
    canActivate: [authGuard, projectAuthGuard] 
  },
  { 
    path: 'projects/:projectId/services/:serviceId/door-setup', 
    loadComponent: () => import('./pages/door-setup/door-setup.page').then(m => m.DoorSetupPage),
    canActivate: [authGuard, projectUpdateAuthGuard],
    canDeactivate: [pageHasChangesGuard]
  },
  { 
    path: 'projects/:projectId/services/:serviceId/doors', 
    loadComponent: () => import('./pages/doors/doors.page').then(m => m.DoorsPage),
    canActivate: [authGuard, projectAuthGuard] 
  },
  { 
    path: 'projects/:projectId/services/:serviceId/messages', 
    loadComponent: () => import('./pages/messages/messages.page').then(m => m.MessagesPage),
    canActivate: [authGuard, projectUpdateAuthGuard] 
  },
  { 
    path: 'projects/:projectId/logs', 
    loadComponent: () => import('./pages/logs/logs.page').then(m => m.LogsPage),
    canActivate: [authGuard, projectUpdateAuthGuard] 
  },
  { 
    path: 'projects/:projectId/customer-messages', 
    loadComponent: () => import('./pages/customer-messages/customer-messages.page').then(m => m.CustomerMessagesPage),
    canActivate: [authGuard, customerMessagesAuthGuard] 
  },
  { 
    path: 'auth-callback', 
    loadComponent: () => import('./pages/auth-callback/auth-callback').then(m => m.AuthCallbackComponent)
  },
  { path: '', redirectTo: 'projects', pathMatch: 'full' },
  { path: '**', redirectTo: 'projects' }
];
